const REASONS = [
  {
    icon: 'ri-footprint-line',
    title: 'Walk to the Trailhead',
    desc: 'Staying near Glen Falls means you can visit the waterfall multiple times during your trip — morning light, golden hour, or after a rain when the falls are at their most dramatic.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Immersed in Forest',
    desc: 'Cabins near Glen Falls sit within the dense hardwood and rhododendron forest that defines the Highlands landscape — a level of natural immersion that more central properties can\'t match.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Still Close to Town',
    desc: 'Despite the secluded feel, cabins near Glen Falls are typically just a 5–10 minute drive from downtown Highlands, putting restaurants, galleries, and shops within easy reach.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Cooler Temperatures',
    desc: 'The forested gorge near Glen Falls stays noticeably cooler than open areas — a welcome feature during summer stays in the mountains.',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Gateway to More Trails',
    desc: 'The Glen Falls area connects to a broader network of hiking trails in the Nantahala National Forest, making it an ideal base for exploring the wider Highlands trail system.',
  },
  {
    icon: 'ri-moon-line',
    title: 'Peaceful Evenings',
    desc: 'The sound of the falls carries through the forest at night, creating a natural white noise backdrop that makes for some of the most restful sleep in the mountains.',
  },
];

export default function WhyStayNearSection() {
  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Location Advantage</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Why Stay Near<br /><em className="italic">Glen Falls?</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto mt-5">
            Location matters in Highlands. Staying near Glen Falls puts you in one of the most scenic and sought-after pockets of the area — close to the falls, deep in the forest, and still within easy reach of town.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REASONS.map((reason) => (
            <div key={reason.title} className="bg-white rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] mb-5">
                <i className={`${reason.icon} text-[#2D4A3E] text-xl`} />
              </div>
              <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-3">{reason.title}</h3>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
